module.exports = __webpack_public_path__ + "img/1.20c37367.jpg";